// src/components/Index.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import LogoutButton from './LogoutButton';
import LoginButtonAlt from './LoginButtonAlt';

function Index() {
    console.log("Index component rendered");  // Debug log to check rendering
    return (
        <div className="index-container">
            <h1>Welcome to Elevate Nampa Group Track</h1>
            <div className="get-started">
                <h2>Get Started</h2>
                <p>Please log in to access the system.</p>
                <LoginButtonAlt />
            </div>
        </div>
    );
}

export default Index;
